import axios from './getAxios';
import { SubscribePayloadProps } from './types'; 

export default async (payload: SubscribePayloadProps) => {
  console.log('payload', payload);

  const { data } = await axios({
    method: 'POST',
    url: `/api/notifications/subscribe?EmailId=${payload.EmailId}`,
    data: payload, 
  });

  return data;
};